import "./tijarassistant.scss"
import CustomTab, {ICustomTab} from "../../../../ui/tab/customtab/customtab";
import * as React from "react";
import {useState} from "react";
import CustomAccordion from "../../../../ui/customaccordion/customaccordion";
import CustomDropzone from "../../../../ui/dropzone/custom/customdropzone";

const TijarAssistant = () => {
    const [activateTitle, setActivateTitle] = useState('tab0');
    const [activateHeader, setActivateHeader] = useState('tab1');
    const customTitleTabItems: ICustomTab[] = [
        {id: 0, title: 'مالی', activate: activateTitle, setActivate: setActivateTitle},
        {id: 1, title: 'مدیریت حساب', activate: activateTitle, setActivate: setActivateTitle},
        {id: 2, title: 'مدیریت کمپین', activate: activateTitle, setActivate: setActivateTitle},
        {id: 3, title: 'تبلیغات', activate: activateTitle, setActivate: setActivateTitle},
        {id: 4, title: 'اسکریپت و ریتارگتینگ', activate: activateTitle, setActivate: setActivateTitle},
        {id: 5, title: 'گزارش ها', activate: activateTitle, setActivate: setActivateTitle},
    ]
    const customHeaderTabItems: ICustomTab[] = [
        {id: 0, title: 'نمایش تبلیغات', activate: activateHeader, setActivate: setActivateHeader},
        {id: 1, title: 'تنظیمات کمپین', activate: activateHeader, setActivate: setActivateHeader},
        {id: 2, title: 'ساخت کمپین', activate: activateHeader, setActivate: setActivateHeader},
    ]

    const renderTitleContents = (current: string): JSX.Element => {
        if (current === 'tab0') {
            return <></>
        } else if (current === 'tab1') {
            return <></>
        } else if (current === 'tab2') {
            return (
                <>
                    {
                        customHeaderTabItems.map((customHeaderTabItem, index) => {
                            return (
                                <CustomTab key={index} id={customHeaderTabItem.id} title={customHeaderTabItem.title}
                                           activate={customHeaderTabItem.activate}
                                           setActivate={customHeaderTabItem.setActivate}/>
                            )
                        })
                    }
                </>
            )
        } else if (current === 'tab3') {
            return <></>
        } else if (current === 'tab4') {
            return <></>
        } else if (current === 'tab5') {
            return <></>
        } else {
            return <></>
        }
    }
    const renderHeaderContents = (current: string): JSX.Element => {
        if (current === 'tab0') {
            return (
                <>
                    <h6 className="pt-5 pb-2">
                        پرسش های متداول
                    </h6>
                    <CustomAccordion
                        title={"چطور بفهمم تبلیغ من در چه وبسایت هایی نمایش داده می شود؟"}
                        body={"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد."}
                    />
                    <CustomAccordion
                        title={"چرا نمایش تبلیغات من شروع نمی شود؟"}
                        body={"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد."}
                    />
                    <CustomAccordion
                        title={"چرا نمایش تبلیغات کمپین من متوقف شده است؟"}
                        body={"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد."}
                    />
                    <CustomAccordion
                        title={"چرا تبلیغاتم را در وبسایت های نمایش دهنده شما نمیبینم؟"}
                        body={"لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد."}
                    />
                    <h6 className="pt-4 pb-1">متن درخواست *</h6>
                    <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                              rows={3}></textarea>
                    <h6 className="pt-4 pb-1">افزودن پیوست</h6>
                    <CustomDropzone/>
                </>
            )
        } else if (current === 'tab1') {
            return (
                <></>
            )
        } else if (current === 'tab2') {
            return (
                <></>
            )
        } else {
            return (
                <></>
            )
        }
    }
    return (
        <div className="Tijar-Assistant">
            <div className="Tijar-Assistant-Header">
                <h6>دستیار تیجار</h6>
                <p>کاربر گرامی لطفا درخواست های پشتیبانی خود را از طریق فرم زیر برای ما ارسال کنید. همچنین در صورت نیاز
                    می توانید با شماره تلفن ۰۲۱۷۷۸۸۹۹۰۷ تماس حاصل فرمایید.</p>
            </div>
            <div className="Tijar-Assistant-Body">
                <h6 className="py-3">موضوع درخواست خود را انتخاب کنید.</h6>
                {
                    customTitleTabItems.map((customTitleTabItem, index) => {
                        return (
                            <CustomTab key={index} id={customTitleTabItem.id} title={customTitleTabItem.title}
                                       activate={customTitleTabItem.activate}
                                       setActivate={customTitleTabItem.setActivate}/>
                        )
                    })
                }
                <h6 className="pt-5 pb-3">عنوان درخواست خود را انتخاب کنید.</h6>
                {renderTitleContents(activateTitle)}
                {renderHeaderContents(activateHeader)}
            </div>
        </div>
    )
}

export default TijarAssistant